import React, { useEffect, useState } from "react";


/**Import Styles and Assets */
import styles from "./Subscription.module.scss";

import back from "./images/back.svg"

import TableLayout from "../../components/TableLayout";
import { useUsersSubscriptionsHeader, useSubscriptionHeader } from "../../schemas/tableHeaderSchema";
import { useDispatch, useSelector } from "react-redux";
import { fetchSubscriptionThunk } from "../../features/SubscriptionReducer";
import { Select } from 'antd';

export default function Subscription() {

    const { data, status } = useSelector(state => state.subscriptions);
    const { search } = useSelector(state => state.search);
    const [list, setList] = useState(data);
    const dispatch = useDispatch();
    const [selectOption, setSelectOption] = useState("active");

    const [isListed, setIsListed] = useState(true);
    const [subscriptionList, setSubscriptionList] = useState([])
    const [userSubscriptionList, setUserSubscriptionList] = useState(subscriptionList);

    const subscriptionHeader = useSubscriptionHeader(setIsListed, setSubscriptionList);
    const userSubscriptionHeader = useUsersSubscriptionsHeader(setSubscriptionList);

    useEffect(() => {
        if (status !== "success") {
            dispatch(fetchSubscriptionThunk());
        }
    }, [])

    useEffect(() => {
        if (!search) return setList(data);


        const array = [
            ...data.map(item => {
                if (item.username.toLowerCase().includes(search.toLowerCase())) {
                    return item
                }
            })
        ].filter(Boolean)
        setList(array);

    }, [data, search])

    useEffect(() => {

        setUserSubscriptionList(subscriptionList)

    }, [search, subscriptionList])

    return isListed ?
        <div className={styles.subscriptions} >
            <h1 className={styles.contentTitle}>Subscriptions</h1>
            <div className={styles.content}>
                <TableLayout headers={subscriptionHeader} data={list} status={status} />
            </div>
        </div > :
        <div className={styles.subscriptions} >
            <div className={styles.bar}>
                <div onClick={() => { setIsListed(true) }} className={styles.backButton}>
                    <img src={back} alt="<" />
                    <h1 className={styles.backButton} >Back</h1>
                </div>
                <div className={styles.selectButton}>
                    <Select
                        className={styles.select}
                        style={{ width: 200 }}
                        value={selectOption}
                        onChange={(e) => setSelectOption(e)}
                        options={[
                            {
                                value: 'active',
                                label: 'Active',
                            },
                            {
                                value: 'expired',
                                label: 'Expired',
                            },

                        ]}
                    />
                </div>
            </div>

            <div className={styles.content}>
                <TableLayout headers={userSubscriptionHeader} data={userSubscriptionList[selectOption]} status={"success"} />
            </div>
        </div >
}